import React, { useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { I18nContext } from "../../../i18n";
import Icons from "../../../scss/prh-icon-sprite.svg";
import FilterField from "./FilterField";
import ToolTip from "../../common/ToolTip";
import { allPatentTypes } from "../../../constants/constants";

const PatentTypeFilter = (props) => {
  const { translate } = useContext(I18nContext);
  const [showFilters, setShowFilters] = useState(false);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const allSelected = () => {
    let selected = true;
    allPatentTypes.forEach((item) => {
      if (!props.searchParams.patentTypes.includes(item)) {
        selected = false;
      }
    });
    return selected;
  };

  const filterList = allSelected() ? [] : props.searchParams.patentTypes;

  const handleClick = (event) => {
    let newFilters = [...filterList];
    if (filterList.includes(event.currentTarget.value)) {
      newFilters = filterList.filter(
        (item) => item.toLowerCase() !== event.currentTarget.value.toLowerCase()
      );
    } else {
      newFilters.push(event.currentTarget.value);
    }
    if (newFilters.length < 1) {
      newFilters = allPatentTypes;
    }
    props.changeFilters(newFilters);
    props.setSearchParams({ ...props.searchParams, patentTypes: newFilters });
  };

  const clearFilters = () => {
    const newParams = { ...props.searchParams, patentTypes: allPatentTypes };
    props.changeFilters(allPatentTypes);
    props.setSearchParams(newParams);
    setShowFilters(true);
  };

  const arrows = (
    <button onClick={toggleFilters} className="select-btn p-0 m-0">
      {showFilters ? (
        <svg
          alt={translate("patent_filtering_close")}
          aria-label={translate("patent_filtering_close")}
          className="filter-arrow-icon float-right p-0"
        >
          <use xlinkHref={`${Icons}#arrow-up`}></use>
        </svg>
      ) : (
        <svg
          alt={translate("patent_filtering_open")}
          aria-label={translate("patent_filtering_open")}
          className="filter-arrow-icon float-right p-0"
        >
          <use xlinkHref={`${Icons}#arrow-down`}></use>
        </svg>
      )}
    </button>
  );

  const clearButton = (
    <button
      className="select-btn text-align-center p-0 pt-1 pb-1 m-0"
      style={{ textAlign: "center" }}
      onClick={clearFilters}
    >
      <span className="float-none">
        {translate("patent.application.clear.button")}
      </span>
    </button>
  );

  const titleField = (
    <Row className="m-0 p-2 align-items-center">
      <Col xs={9} className="pr-0">
        <Row>
          <Col
            xs={"auto"}
            className="pr-0"
            style={{ display: "flex", alignItems: "center" }}
          >
            <button
              aria-expanded={showFilters}
              onClick={toggleFilters}
              className="select-btn p-0 m-0"
              focus="false"
            >
              <h4
                className="selection-title m-0"
                style={{ fontSize: "1.1rem" }}
              >
                {translate("patent_type_filtering")}
              </h4>
            </button>
          </Col>
          <Col xs={"auto"} className="pl-0 pr-0">
            <ToolTip
              text={translate("patent_infotext_typefilter")}
              id="ptTypeTooltip"
            />
          </Col>
        </Row>
      </Col>
      <Col xs={3} className="pl-0">
        {allSelected() ? arrows : clearButton}
      </Col>
    </Row>
  );

  return (
    <div>
      <div
        aria-describedby="ptTypeTooltip"
        style={{ backgroundColor: "white" }}
      >
        {titleField}
        {showFilters || !allSelected() ? (
          <div>
            {allPatentTypes.map((item) => (
              <FilterField
                text={translate("patent_type_" + item.toLowerCase())}
                key={item}
                value={item}
                handleClick={handleClick}
                selected={filterList.includes(item)}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PatentTypeFilter;
